import { createReactRenderer } from 'root/apps/helpers/react-renderer';

import BannerContent from './BannerContent';

export default BannerContent;

const RenderedComponent = createReactRenderer({
  component: BannerContent,
  selector: '[data-react-root="BannerContent"]',
});

// Mount/unmount when the reports tab is shown/hidden
history.onChangeState(
  [{ form_name: 'ui_tab', tab: 'reports' }],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
